@if (directNavigation) {
  <router-outlet></router-outlet>
} @else {
  <nbd-navigation></nbd-navigation>
}
